const ATTRIBUTION_KEY = 'aipsyhelp_attribution_v1';
const ATTR_PARAMS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'gclid',
  'gbraid',
  'wbraid',
  'fbclid',
  'msclkid'
];

function safeStorageGet(key) {
  try {
    return sessionStorage.getItem(key);
  } catch (_) {
    return null;
  }
}

function safeStorageSet(key, value) {
  try {
    sessionStorage.setItem(key, value);
  } catch (_) {
    // ignore
  }
}

/**
 * Capture paid/organic attribution params once per session.
 * First-touch wins so mid-funnel navigation does not overwrite the original Ads click.
 */
export function captureAttributionFromLocation(search = typeof window !== 'undefined' ? window.location.search : '') {
  if (typeof window === 'undefined') return getAttribution();

  const existing = getAttribution();
  if (existing && Object.keys(existing).length > 0) {
    return existing;
  }

  const params = new URLSearchParams(search);
  const captured = {};

  ATTR_PARAMS.forEach((key) => {
    const value = params.get(key);
    if (value) captured[key] = value;
  });

  if (Object.keys(captured).length > 0) {
    captured.landing_path = `${window.location.pathname}${window.location.search}`;
    captured.captured_at = new Date().toISOString();
    safeStorageSet(ATTRIBUTION_KEY, JSON.stringify(captured));
  }

  return captured;
}

export function appendAttributionParams(url, attribution = getAttribution()) {
  if (!url) return url;

  try {
    const next = new URL(
      url,
      typeof window !== 'undefined' ? window.location.origin : 'https://ai.psyhelp.info'
    );
    Object.entries(attribution || {}).forEach(([key, value]) => {
      if (!ATTR_PARAMS.includes(key) || !value || next.searchParams.has(key)) return;
      next.searchParams.set(key, String(value));
    });
    return next.toString();
  } catch (_) {
    return url;
  }
}

export function getAttribution() {
  const raw = safeStorageGet(ATTRIBUTION_KEY);
  if (!raw) return {};

  try {
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch (_) {
    return {};
  }
}

export function formatAttributionForMessage(attribution = getAttribution()) {
  const entries = Object.entries(attribution || {}).filter(([, value]) => value);
  if (!entries.length) return '';

  return entries.map(([key, value]) => `${key}=${value}`).join(' | ');
}

export function buildLeadMessage({ pageType, placement, pagePath, attribution }) {
  const attrLine = formatAttributionForMessage(attribution);
  const parts = [
    `Lead form: ${pageType} / ${placement}`,
    pagePath ? `Page: ${pagePath}` : null,
    attrLine ? `Attribution: ${attrLine}` : 'Attribution: direct/unknown'
  ].filter(Boolean);

  return parts.join('\n');
}
